import React, { useRef } from 'react';

import { Field, ServiceTypeahead } from '@zapier/design-system';

import type { Service } from './types';

type Props = {
  onChangeService: (service: Service) => void;
};

function FieldService(props: Props) {
  const { onChangeService } = props;

  const refRoot = useRef<HTMLDivElement>();

  return (
    <div ref={refRoot}>
      <Field
        isRequired={true}
        label="Integration"
        renderHelpText={() => <p>Select the integration you want to join</p>}
        renderInput={() => (
          <ServiceTypeahead
            apiHostname={process.env.ZAPIER_API_BASE_URL}
            aria-label="Integrations"
            includeIsAppAdmin={false}
            includeIsAppCollaborator={false}
            menuAriaLabel="List of available integrations"
            onChange={onChangeService}
            placeholder="Select your integration"
            resultsLimit={8}
          />
        )}
      />
    </div>
  );
}

export default FieldService;
